// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__2zdlK","backgroundImage":"Tile_backgroundImage__2uu4N"};